import React from "react";

import { Flow, FlowVersion } from "src/api/flowTypes";
import { useTestDatasets } from "src/datasets/api/queries";
import { RunFlowButton } from "src/flowContainer/RunFlowButton/RunFlowButton";
import { useAuthoringContext } from "src/router/routerContextHooks";

type WrapperProps = {
  flow: Flow;
  version: FlowVersion;
};

export const RunFlowButtonWrapper: React.FC<WrapperProps> = ({
  flow,
  version,
}) => {
  const { workspace } = useAuthoringContext();
  const { testRunDatasets, isLoading } = useTestDatasets({
    flowId: flow.id,
    baseUrl: workspace.base_url,
  });

  return (
    <RunFlowButton
      key={version.id}
      datasets={testRunDatasets}
      flow={flow}
      isLoading={isLoading}
      version={version}
    />
  );
};
